import React, { useContext, useState } from "react";
import { Link, Navigate, useNavigate, useSearchParams } from "react-router-dom";
import InputField from "../../Components/InputField";
import { postData } from "../../Utils/AxiosRequest";
import {
  API_PATHS,
  errorMessages,
  URL_PATH,
} from "../../Utils/Constants/constants";
import { Spinner } from "react-bootstrap";
import CenterModal from "../../Components/CenterModal";
import { LoginContext } from "../../Contexts/LoginContext";
import { clearSession, createSession } from "../../Utils/Auth/session";
// import ReCAPTCHA from "react-google-recaptcha";
import { encryptPassword } from "../../Utils/Auth/encription";
import LoginOtp from "./LoginOtp";
import { generateMathCaptcha } from "../../Utils/Auth/captchaAuth";
import Captcha from "./Captcha";

const Login = () => {
  // const captchaSiteKey = process.env.REACT_APP_CAPTCHA_SITEKEY;
  const { isLoggedIn, setIsLoggedIn } = useContext(LoginContext);
  const [data, setData] = useState({
    Email: "",
    Password: "",
    Mobile: "",
    rememberMe: false,
  });
  const [showModal, setShowModal] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [enterOtp, setEnterOtp] = useState(false);
  // TODO: Handle mobile number Error display on UI.
  const [mobileNumberError, setMobileNumberError] = useState(null);
  const [loginWithOtp, setLoginWithOtp] = useState(false);
  const [captchaToken, setCaptchaToken] = useState(generateMathCaptcha());
  const [userCaptcha, setUserCaptcha] = useState("");
  const [message, setMessage] = useState({
    heading: "",
    description: "",
  });
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const redirectTo = params.get("redirect");
  const redirectToMatrimonial = redirectTo === "matrimonial";

  const handleChange = (e) => {
    const mobileRegex = /^\d{1,10}$/;
    const name = e.target.name;
    const value = e.target.value;

    if (name === "Mobile" && value.length !== 0 && !mobileRegex.test(value)) {
      return;
    }

    setData((prvs) => {
      const newData = { ...prvs, [name]: value };
      return newData;
    });
  };

  const handleCaptchaChange = () => {
    setCaptchaToken(generateMathCaptcha());
    setUserCaptcha("");
  };

  const handleToggleLoginWithOtp = (e) => {
    e.preventDefault();
    setData({
      Email: data.Email,
      Password: loginWithOtp ? data.Password : "",
      Mobile: loginWithOtp ? "" : data.Mobile,
      rememberMe: data.rememberMe,
    });
    if (loginWithOtp) {
      setMobileNumberError(null);
    }
    setLoginWithOtp(!loginWithOtp);
  };

  const handleGetOtp = async () => {
    const reqBody = {
      Username: data.Email.trim(),
      Mobile: data.Mobile,
    };

    try {
      const response = await postData(API_PATHS.sendOtp, reqBody);

      if (response.status === 200) {
        if (response.data.IsSuccess) {
          setEnterOtp(true);
        } else {
          handleCaptchaChange();
          const responseMessage = response.data.Message ?? "";
          setShowModal(true);
          setMessage({
            heading: errorMessages.error,
            description: responseMessage,
          });
        }
      }
    } catch (error) {
      handleCaptchaChange();
      console.error(error);
      setShowModal(true);
      setMessage({
        heading: errorMessages.error,
        description: errorMessages.errorDescription,
      });
    }
  };

  const onLoginSuccess = async (response) => {
    clearSession();
    const responseData = response?.data?.Response;
    const token = responseData?.MemberToken ?? "";
    const refreshToken = responseData?.TokenRefresh ?? "";
    const id = responseData?.MemberId ?? "";
    if (!token || !id) {
      setShowModal(true);
      setMessage({
        heading: "Somethig went wrong",
        description: "Please try again later",
      });
    }
    if (responseData?.IsPaymentCompleted && responseData?.IsApproved) {
      createSession(token, id, data.rememberMe, refreshToken);
      setIsLoggedIn(true);
      if (redirectToMatrimonial) {
        navigate(URL_PATH.matrimonialdahboard);
      } else {
        navigate(URL_PATH.memberhome);
      }
    } else {
      // navigate(URL_PATH.payment, {
      //   state: { MemberId: id },
      // });
      const requestBody = {
        PaymentId: id,
        MemberId: id,
        TransactionId: id,
        PaymentAmount: 200,
        PaymentStatus: "success",
        PaymentMethod: "upi",
        PaymentDate: new Date(),
        CurrencyCode: "INR",
        GatewayResponse: "success",
        ErrorDescription: "none",
        ErrorCode: "0",
      };
      try {
        const response = await postData(API_PATHS.createPayment, requestBody);
        if (response.status === 200) {
          navigate(URL_PATH.login);
        } else {
          setShowModal(true);
          setMessage({
            heading: "Registration Successful",
            description: "Please login to complete payment",
          });
        }
      } catch (error) {
        setShowModal(true);
        setMessage({
          heading: "Registration Successful",
          description: "Please login to complete payment",
        });
      }
    }
  };

  const onLoginFaliure = async (message) => {
    handleCaptchaChange();
    switch (message) {
      case "Member Email OR Password is Mismatched!":
        setShowModal(true);
        setMessage({
          heading: "Invalid Cradentials",
          description: "Please check your email and password",
        });
        break;
      case "Member is Rejected!":
        setShowModal(true);
        setMessage({
          heading: "Application rejected by admin.",
          description: "Please contact admin.",
        });
        break;
      case "Member Does not Exists!":
        setShowModal(true);
        setMessage({
          heading: "Invalid Credentials",
          description: "Email not registered",
        });
        break;
      case "Member`s approval is pending!":
        setShowModal(true);
        setMessage({
          heading: "Approved Pending",
          description: "Approval is Pending. Please contact admin.",
        });
        break;
      case "OTP mismatch!!!":
        setShowModal(true);
        setMessage({
          heading: "Invalid OTP",
          description: "OTP is invalid.",
        });
        break;
      case "OTP expired!!!":
        setShowModal(true);
        setMessage({
          heading: "Invalid OTP",
          description: "OTP Expired.",
        });
        break;
      default:
        setShowModal(true);
        setMessage({
          heading: errorMessages.error,
          description: errorMessages.errorDescription,
        });
        break;
    }
    setData({
      Email: data.Email,
      Password: "",
      rememberMe: data.rememberMe,
    });
  };

  const handleLoginWithEmailPass = async () => {
    try {
      const reqBody = {
        Email: data.Email.trim(),
        Password: encryptPassword(data.Password.trim()),
      };

      const response = await postData(API_PATHS.loginMember, reqBody);

      if (response.status === 200) {
        if (response.data.IsSuccess) {
          await onLoginSuccess(response);
        } else {
          const message = response.data.Message ?? "";
          onLoginFaliure(message);
        }
      }
    } catch (error) {
      console.error(error);
      setShowModal(true);
      setMessage({
        heading: errorMessages.error,
        description: errorMessages.errorDescription,
      });
    }
  };

  const handleLogin = async (e) => {
    e.preventDefault();
    if (!data.Email || (!data.Password && !data.Mobile)) {
      return;
    }
    if (loginWithOtp && data.Mobile.length < 10) {
      setMobileNumberError("Please enter a valid mobile number.");
      return;
    }
    setIsSubmitting(true);
    if (parseInt(userCaptcha) !== captchaToken.answer) {
      setShowModal(true);
      setMessage({
        heading: "Invalid Captcha",
        description: "Please complete CAPTCHA verification",
      });
      setIsSubmitting(false);
      return;
    }

    if (loginWithOtp) {
      await handleGetOtp();
    } else {
      await handleLoginWithEmailPass();
    }
    setIsSubmitting(false);
  };

  if (isLoggedIn) {
    if (redirectToMatrimonial) {
      return <Navigate to={URL_PATH.matrimonialdahboard} />;
    } else {
      return <Navigate to={URL_PATH.memberhome} />;
    }
  }

  return (
    <section className="main-login">
      <div className="main-login-bg">
        <div className="container">
          {redirectToMatrimonial && (
            <p className="text-center text-success">
              Welcome to All India Momin Conference
            </p>
          )}
          <div className="login-container pb-4">
            <h3 className="main-title mb-3">Login</h3>
            <div className="common-form">
              {enterOtp ? (
                <LoginOtp
                  email={data.Email}
                  mobile={data.Mobile}
                  onSuccess={onLoginSuccess}
                  onFailure={onLoginFaliure}
                  resendOtp={handleGetOtp}
                />
              ) : (
                <form onSubmit={handleLogin}>
                  <div className="form-group">
                    <InputField
                      type="email"
                      placeholder="User Name"
                      name="Email"
                      value={data.Email}
                      onChange={handleChange}
                      autoComplete="off"
                      required
                    />
                  </div>
                  {loginWithOtp ? (
                    <div className="form-group">
                      <InputField
                        type="text"
                        placeholder="Mobile Number"
                        name="Mobile"
                        value={data.Mobile}
                        onChange={handleChange}
                        autoComplete="off"
                        required
                      />
                    </div>
                  ) : (
                    <div className="form-group">
                      <InputField
                        type="password"
                        placeholder="Password"
                        name="Password"
                        value={data.Password}
                        onChange={handleChange}
                        autoComplete="off"
                        onPaste={(e) => {
                          e.preventDefault();
                          return false;
                        }}
                        onCopy={(e) => {
                          e.preventDefault();
                          return false;
                        }}
                        required
                      />
                    </div>
                  )}
                  {/* {data.Email && (data.Password || data.Mobile) ? <div className="d-flex justify-content-center py-2">
                      <ReCAPTCHA
                        sitekey={captchaSiteKey}
                        onChange={handleCaptchaChange}
                      />
                    </div> : <></>} */}
                  {data.Email && (data.Password || data.Mobile) ? (
                    <div className="d-flex justify-content-center mb-3">
                      <Captcha
                        captcha={captchaToken}
                        setUserCaptcha={setUserCaptcha}
                        userCaptcha={userCaptcha}
                        refreshCaptcha={handleCaptchaChange}
                      />
                    </div>
                  ) : (
                    <></>
                  )}
                  <div className="checkgroup">
                    <div className="custom-control custom-checkbox">
                      <InputField
                        type="checkbox"
                        className="custom-control-input"
                        id="customCheck"
                        name="rememberMe"
                        value={data.rememberMe}
                        onChange={handleChange}
                      />
                      <label
                        className="custom-control-label"
                        htmlFor="customCheck"
                      >
                        Remember Me
                      </label>
                    </div>
                    <div>
                      <Link
                        to="/forgotpassword"
                        className="green-text text-underline"
                      >
                        Forgot Password?
                      </Link>
                    </div>
                  </div>
                  {mobileNumberError && (
                    <div className="pb-2">
                      <p className="text-danger text-left p-0 m-0">{`* ${mobileNumberError}`}</p>
                    </div>
                  )}
                  <div className="form-group">
                    {isSubmitting ? (
                      <button
                        className="btn green-btn  w-100 cursor-na"
                        disabled
                      >
                        <Spinner size="sm" />
                      </button>
                    ) : (
                      <input
                        type="submit"
                        className="btn green-btn  w-100"
                        value={loginWithOtp ? "Get Otp" : "Login"}
                      />
                    )}
                  </div>
                </form>
              )}
              <div>
                Don’t Have any Account?{" "}
                <Link to="/membership" className="green-text font-weight-bold">
                  Sign Up
                </Link>
              </div>
              <div className="login-option-or">
                <p>
                  <small className="bg-white p-1">OR</small>
                </p>
              </div>
              <div className="login-option">
                {loginWithOtp ? (
                  <button
                    type="button"
                    className="btn p-0 m-0 text-primary"
                    onClick={handleToggleLoginWithOtp}
                  >
                    <small>Login with Username and Password.</small>{" "}
                  </button>
                ) : (
                  <button
                    type="button"
                    className="btn p-0 m-0 text-primary"
                    onClick={handleToggleLoginWithOtp}
                  >
                    <small>Login with OTP.</small>
                  </button>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      <CenterModal
        show={showModal}
        onClose={() => {
          setShowModal(false);
        }}
        heading={message.heading}
        description={message.description}
        buttonText={"Try again"}
      />
    </section>
  );
};

export default Login;
